import { createSelector } from '@reduxjs/toolkit';
import { OFFERINGS_SLICE_NAME, OfferingsState } from './offerings.types';

export const selectOfferingsState = (state) => state[OFFERINGS_SLICE_NAME];

export const selectChosenGymID = createSelector(
  selectOfferingsState,
  (offeringsState: OfferingsState) => offeringsState?.chosenGymID,
);

export const selectChosenSocialEventID = createSelector(
  selectOfferingsState,
  (offeringsState: OfferingsState) => offeringsState?.chosenSocialEventID,
);

export const selectChosenPin = createSelector(
  selectOfferingsState,
  (offeringsState: OfferingsState) => offeringsState?.chosenPin,
);

export const selectMobileFilterDrawerForGymsIsOpen = createSelector(
  selectOfferingsState,
  (offeringsState: OfferingsState) =>
    !!offeringsState?.mobileFilterDrawerForGymsIsOpen,
);

export const selectMobileFilterDrawerForSocialEventsIsOpen = createSelector(
  selectOfferingsState,
  (offeringsState: OfferingsState) =>
    !!offeringsState?.mobileFilterDrawerForSocialEventsIsOpen,
);

export const selectMapIsVisible = createSelector(
  selectOfferingsState,
  (offeringsState: OfferingsState) => offeringsState?.mapIsVisible,
);

export const selectMapViewport = createSelector(
  selectOfferingsState,
  (offeringsState: OfferingsState) => offeringsState?.viewport,
);

export const selectIsSearchArea = createSelector(
  selectOfferingsState,
  (offeringState: OfferingsState) => offeringState?.viewportIsSearchArea,
);

export const selectIsSocialEventsTriggeredFromFitness = createSelector(
  selectOfferingsState,
  (offeringState: OfferingsState) =>
    offeringState?.isSocialEventsTriggeredFromFitness,
);

export const selectUserPreferenceOfMap = createSelector(
  selectOfferingsState,
  (offeringsState: OfferingsState) => offeringsState?.userPreferenceOfMap,
);
